import styled from "styled-components";
import { LabelCell } from "./Layout.styles";
import { CustomButton, FlexContainer } from "@mindmemobile/mm-shared-global";
import { DescriptionCell } from "./CommonStyles";
import { CheckoutIframeWrapper } from "./StyledComponents";

export const SubscriptionStylesWrapper = styled.div`
  .usd-grey {
    font-size: 16px;
    font-weight: 400;
    color: #aaa;
    margin-left: 10px;
  }
  .blue-label-container {
    ${LabelCell} label {
      color: #556bb8;
    }
    ${CustomButton} {
      font-size: 14px;
      font-weight: 600;
      min-width: 70px;
    }
  }
  .blue-description-container {
    ${DescriptionCell} label:not(.standard-color) {
      color: #556bb8;
    }
    .border-top-grey {
      border-top: 1px solid #ccc;
      padding-top: 12px;
    }
  }
  .payment-card-name {
    height: 22px;
    width: 30px;
    margin-right: 15px;
  }
  .default-card-name {
    height: 16px;
    width: 20px;
    margin-right: 8px;
  }
  .header-midnight-blue {
    color: #2c3e50;
    font-size: 20px;
    font-weight: 600;
    line-height: 26px;
    margin: 30px 0px;
    img {
      width: 17px;
      height: 17px;
      margin-left: 13px;
      margin-bottom: 6px;
      cursor: pointer;
    }
  }
  .beneficiary-block {
    ${LabelCell} {
      margin-top: 15px;
    }
  }
  .span-semi-bold {
    span {
      font-weight: 600;
    }
  }
  .related-label {
    max-width: 380px;
    margin-bottom: 4px;
    div {
      &:first-child {
        flex: 1 1 0;
        label {
          color: #556bb8;
          cursor: pointer;
        }
      }
      &:not(:first-child) {
        width: 100px;
      }
    }
  }
  &.purchase-link-detail-page {
    .fa-chevron-left {
      font-size: 20px;
      margin-top: 4px;
    }
    .purchase-link-topbar {
      justify-content: space-between;
      padding: 0px 0px 50px;
      align-items: center;
      > div {
        min-width: 235px;
        width: auto;
      }
    }
    .pl-status-label {
      // pl stands for purchase link
      label {
        line-height: 40px;
      }
    }
    .label-description-row {
      margin: 0px 0px 30px;
    }
    .pl-sub-header {
      margin: 0px 0px 30px;
      font-size: 18px;
      font-weight: 600;
      & + div.full-width ${FlexContainer} {
        margin-bottom: 5px;
        align-items: center;
      }
    }
    .pl-option-block {
      width: 50%;
    }
    .sharing-selected-option {
      margin-top: 30px;
      .detail-link {
        word-break: break-all;
      }
    }
    .after-pay-select {
      width: 250px;
      .header {
        width: 250px;
      }
    }
    .sharing-qr-code {
      height: auto;
      margin: 0 auto;
      max-width: 64px;
      width: 100%;
    }
    .link-tick-icon {
      height: 23px;
      width: 20px;
      margin-left: 5px;
      cursor: pointer;
    }
    .link-cross-icon {
      height: 21px;
      width: 18px;
      margin-left: 2px;
      cursor: pointer;
    }
    .link-input {
      min-width: 250px;
      max-width: 450px;
    }
    ${CheckoutIframeWrapper} {
      width: 100%;
    }
    @media (min-width: 1600px) and (max-width: 2200px) {
      ${CheckoutIframeWrapper} {
        width: 100%;
      }
    }
  }
`;
